

(function () {
  'use strict';

  var productCache = {};

  var SIZE_MAP = {
    'X-Small': 'XS', 'Small': 'S', 'Medium': 'M',
    'Large': 'L', 'X-Large': 'XL', '2XL': '2XL', '3XL': '3XL'
  };

  function init() {
    document.querySelectorAll('.wc-quick-add').forEach(function (container) {
      
      if (container.dataset.wcInitialized) return;
      container.dataset.wcInitialized = 'true';

      var btn = container.querySelector('.wc-quick-add__btn');
      var handle = container.dataset.productHandle;
      var singleVariant = container.dataset.singleVariant;

      if (!btn || !handle) return;

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        if (singleVariant) {
          
          addToCart(container, singleVariant);
        } else {
          
          showSizes(container, handle);
        }
      });
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('.wc-quick-add')) {
        document.querySelectorAll('.wc-quick-add__sizes:not([hidden])').forEach(function (el) {
          el.setAttribute('hidden', '');
          el.innerHTML = '';
          var btn = el.closest('.wc-quick-add').querySelector('.wc-quick-add__btn');
          if (btn) btn.removeAttribute('hidden');
        });
      }
    });
  }

  function showSizes(container, handle) {
    var btn = container.querySelector('.wc-quick-add__btn');
    var sizesEl = container.querySelector('.wc-quick-add__sizes');
    if (!sizesEl) return;

    var embeddedData = container.dataset.variants;
    if (embeddedData) {
      try {
        var variants = JSON.parse(embeddedData);
        renderSizeButtons(container, variants);
        return;
      } catch (e) {
        console.error('[WC Quick Add] Failed to parse embedded variants:', e);
      }
    }

    btn.textContent = '...';
    btn.setAttribute('disabled', '');

    if (productCache[handle]) {
      renderSizeButtons(container, productCache[handle].variants);
      return;
    }

    fetch('/products/' + handle + '.json')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        productCache[handle] = data.product;
        renderSizeButtons(container, data.product.variants);
      })
      .catch(function (err) {
        console.error('[WC Quick Add] Fetch error:', err);
        btn.textContent = '+ Quick Add';
        btn.removeAttribute('disabled');
      });
  }

  function renderSizeButtons(container, variants) {
    var btn = container.querySelector('.wc-quick-add__btn');
    var sizesEl = container.querySelector('.wc-quick-add__sizes');

    btn.setAttribute('hidden', '');

    var html = '';
    variants.forEach(function (variant) {
      var sizeName = variant.option1 || variant.title;
      var abbr = SIZE_MAP[sizeName] || sizeName;
      var available = variant.available;
      html += '<button type="button" class="wc-quick-add__size-btn' +
        (!available ? ' wc-quick-add__size-btn--unavailable' : '') +
        '" data-variant-id="' + variant.id + '"' +
        (!available ? ' disabled' : '') +
        '>' + abbr + '</button>';
    });
    sizesEl.innerHTML = html;
    sizesEl.removeAttribute('hidden');

    sizesEl.querySelectorAll('.wc-quick-add__size-btn').forEach(function (sizeBtn) {
      sizeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (sizeBtn.hasAttribute('disabled')) return;
        addToCart(container, sizeBtn.dataset.variantId, sizeBtn.textContent);
      });
    });
  }

  function addToCart(container, variantId, sizeName) {
    var btn = container.querySelector('.wc-quick-add__btn');
    var sizesEl = container.querySelector('.wc-quick-add__sizes');
    var statusEl = container.querySelector('.wc-quick-add__status');

    if (btn) btn.setAttribute('hidden', '');
    if (sizesEl) sizesEl.setAttribute('hidden', '');
    if (statusEl) {
      statusEl.removeAttribute('hidden');
      statusEl.className = 'wc-quick-add__status wc-quick-add__status--adding';
      statusEl.textContent = 'Adding...';
    }

    var body = JSON.stringify({
      items: [{ id: parseInt(variantId), quantity: 1 }]
    });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: body
    })
      .then(function (r) { return r.json(); })
      .then(function (response) {
        if (response.status) {
          
          showError(container, response.description || 'Error adding to cart');
          return;
        }

        if (statusEl) {
          statusEl.className = 'wc-quick-add__status wc-quick-add__status--added';
          statusEl.textContent = '\u2713 Added' + (sizeName ? ' \u2014 ' + sizeName : '');
        }

        fetchCartAndOpenDrawer();

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'wc-quick-add',
            productVariantId: variantId,
            cartData: response
          });
        }

        setTimeout(function () {
          resetToDefault(container);
        }, 1500);
      })
      .catch(function (err) {
        console.error('[WC Quick Add] Cart add error:', err);
        showError(container, 'Error adding to cart');
      });
  }

  function fetchCartAndOpenDrawer() {
    var cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;

    fetch('/cart?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var newDrawerInner = parsed.querySelector('.drawer__inner');
        var currentDrawerInner = document.querySelector('.drawer__inner');
        if (newDrawerInner && currentDrawerInner) {
          currentDrawerInner.innerHTML = newDrawerInner.innerHTML;
        }

        fetch('/cart?section_id=cart-icon-bubble')
          .then(function (r) { return r.text(); })
          .then(function (bubbleHtml) {
            var parsedBubble = new DOMParser().parseFromString(bubbleHtml, 'text/html');
            var newBubble = parsedBubble.querySelector('.shopify-section');
            var currentBubble = document.getElementById('cart-icon-bubble');
            if (newBubble && currentBubble) {
              currentBubble.innerHTML = newBubble.innerHTML;
            }
          });

        setTimeout(function () {
          var overlay = document.getElementById('CartDrawer-Overlay');
          if (overlay) {
            overlay.addEventListener('click', function () { cartDrawer.close(); });
          }
          cartDrawer.classList.remove('is-empty');
          cartDrawer.open();
        }, 100);
      })
      .catch(function (err) {
        console.error('[WC Quick Add] Cart drawer update error:', err);
      });
  }

  function resetToDefault(container) {
    var btn = container.querySelector('.wc-quick-add__btn');
    var sizesEl = container.querySelector('.wc-quick-add__sizes');
    var statusEl = container.querySelector('.wc-quick-add__status');

    if (btn) {
      btn.textContent = '+ Quick Add';
      btn.removeAttribute('disabled');
      btn.removeAttribute('hidden');
    }
    if (sizesEl) {
      sizesEl.setAttribute('hidden', '');
      sizesEl.innerHTML = '';
    }
    if (statusEl) {
      statusEl.setAttribute('hidden', '');
      statusEl.textContent = '';
    }
  }

  function showError(container, message) {
    var statusEl = container.querySelector('.wc-quick-add__status');
    if (statusEl) {
      statusEl.className = 'wc-quick-add__status wc-quick-add__status--error';
      statusEl.textContent = message;
    }
    setTimeout(function () { resetToDefault(container); }, 2000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length) {
        var hasNewQuickAdd = false;
        mutations[i].addedNodes.forEach(function (node) {
          if (node.nodeType === 1 && (node.classList.contains('wc-quick-add') || node.querySelector('.wc-quick-add'))) {
            hasNewQuickAdd = true;
          }
        });
        if (hasNewQuickAdd) {
          init();
          break;
        }
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

})();
